export const assigneeStatuses = Object.freeze({
  complete: "complete",
  late: "late",
  incomplete: "incomplete"
});
